import Option from './Option'

export { default as Option } from './Option'
export { default as OptionContext, OptionContextState } from './OptionContext'
export { default as Selector } from './Selector'

export const ColorOption = new Option({
  key: 'color',
  label: '🎨 Circle Color',
})

export const FaceOption = new Option({
  key: 'faceType',
  label: '🤖 Face',
})

export const FaceColorOption = new Option({
  key: 'faceColor',
  label: '↳ 🎨 Color',
})

export const TextureOption = new Option({
  key: 'textureType',
  label: '↳ 🤚 Texture',
})

export const EyesOption = new Option({
  key: 'eyeType',
  label: '👁 Eyes',
})

export const MouthOption = new Option({
  key: 'mouthType',
  label: '👄 Mouth',
})

export const TopOption = new Option({
  key: 'topType',
  label: '🎩 Top',
})

export const TopColorOption = new Option({
  key: 'topColor',
  label: '↳ 🎨 Top',
})

export const SidesOption = new Option({
  key: 'sideType',
  label: '👂 Sides',
})

export const SidesColorOption = new Option({
  key: 'sidesColor',
  label: '↳ 🎨 Sides',
})

// Avataars
export const AccessoriesOption = new Option({
  key: 'accessoriesType',
  label: '↳ 👓 Accessories',
})

export const HatColorOption = new Option({
  key: 'hatColor',
  label: '🎨 HatColor',
})

export const HairColorOption = new Option({
  key: 'hairColor',
  label: '↳ 💈 Hair Color',
})

export const FacialHairOption = new Option({
  key: 'facialHairType',
  label: 'Facial Hair',
})

export const FacialHairColor = new Option({
  key: 'facialHairColor',
  label: '↳ ✂️ Facial Hair Color',
})

export const ClotheOption = new Option({
  key: 'clotheType',
  label: '👔 Clothes',
})

export const ClotheColorOption = new Option({
  key: 'clotheColor',
  label: '↳ Color Fabric',
})

export const GraphicOption = new Option({
  key: 'graphicType',
  label: '↳ Graphic',
})

export const EyebrowOption = new Option({
  key: 'eyebrowType',
  label: '✏️ Eyebrow',
})

export const SkinOption = new Option({
  key: 'skinColor',
  label: '🎨 Skin',
})

export const allOptions = [
  ColorOption,
  TopOption,
  TopColorOption,
  FaceOption,
  FaceColorOption,
  TextureOption,
  EyesOption,
  MouthOption,
  SidesOption,
  SidesColorOption,
]



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/bottts/options/index.tsx